import leader6 from "../assets/LandingImages/rajasreems.png";
import leader5 from "../assets/LandingImages/drshalijpr.jpg";
import leader4 from "../assets/LandingImages/ishitaroy.png";
// frontend/src/assets/LandingImages/Ishita.jpg
import leader2 from "../assets/LandingImages/prajeev.png";
import leader1 from "../assets/LandingImages/pinarayi.png";
import leader3 from "../assets/LandingImages/rbindu.jpg";
import mainEvent1Image from "../assets/LandingImages/image3.jpg";
import seminar from "../assets/LandingImages/seminar.jpg";
import leader7 from "../assets/LandingImages/granil.jpg";
import leader8 from "../assets/LandingImages/shivankutty.jpg";
// import seminar  from '../assets/LandingImages/seminar.jpg'
import panel from "../assets/LandingImages/panelDiscussion.jpg";
import panel2 from "../assets/LandingImages/panelReplace.jpg";
import inaugration from "../assets/LandingImages/inauguration.jpg";
import celebration from "../assets/LandingImages/celebration.jpg";


import ajaysir from "../assets/DevelopersImages/ajaysir.jpg";
import premsir from "../assets/DevelopersImages/premsir.jpg";
import sonisir from "../assets/DevelopersImages/sonisir.jpg";
import joseph from "../assets/DevelopersImages/joseph.jpg";
import manu from "../assets/DevelopersImages/manu.jpg";
import akash from "../assets/DevelopersImages/akash.jpg";
import badu from "../assets/DevelopersImages/badu.jpg";
import hridya from "../assets/DevelopersImages/hridya.jpg";
import marrea from "../assets/DevelopersImages/marrea.jpg";
import pranav from "../assets/DevelopersImages/pranav.jpg";

export const LEADERS_SECTION_DETAILS = [
  {
    image: leader1,
    name: "Sri. Pinarayi Vijayan",
    title: "Chief Minister",
    organization: "Government of Kerala",
    details:
      "Sri. Pinarayi Vijayan is a prominent Indian politician and the current Chief Minister of Kerala, serving since May 2016. Sri. Pinarayi Vijayan has been a pivotal figure in Kerala's political landscape for several decades, known for his strong leadership and administrative acumen. His government has focused on fostering sustainable development, empowering the working class, and improving public education.",
    site: "https://keralacm.gov.in/",
  },
  {
    image: leader3,
    name: "Dr. R Bindu",
    title: "Minister for Higher Education and Social Justice",
    organization: "Government of Kerala",
    details:
      "Dr. R. Bindu is a distinguished academician and politician, currently serving as the Minister for Higher Education and Social Justice in Kerala.She served as an Associate Professor in the Department of English at Sree Kerala Varma College, Thrissur,She served as the first woman Mayor of Thrissur,Her tenure as Mayor was marked by efforts to improve urban infrastructure, promote environmental sustainability, and enhance civic engagement.",
    site: "https://minister-highereducation.kerala.gov.in",
  },
  {
    image: leader8,
    name: "Sri. V Sivankutty",
    title: "Minister for General Education and Labour",
    organization: "Government of Kerala",
    details:
      "Sri. V. Sivankutty is the current Minister for General Education and Labour in Kerala. As Minister for General Education, Sivankutty has focused on transforming Kerala's public education system by improving infrastructure, updating curricula, and ensuring access to quality education for all students. His efforts have also centered on bridging the digital divide, promoting digital education, and enhancing the global competitiveness of Kerala's schools.",
    // site:'https://minister-highereducation.kerala.gov.in'
  },
  {
    image: leader2,
    name: "Sri. P Rajeev",
    title: "Minister for Industries, Law and Coir",
    organization: "Government of Kerala",
    details: "P. Rajeev is a seasoned politician and the current Minister for Law, Industries, and Coir in Kerala. Prior to his ministerial role, Rajeev served as a Member of Parliament (Rajya Sabha) from 2009 to 2015. Under his leadership, the state has been working to simplify industrial policies, attract investments, aiming to make Kerala a preferred destination for entrepreneurs and businesses. ",
    site: 'https://minister-industries.kerala.gov.in/'
  },
  {
    image: leader7,
    name: "Sri. G R Anil",
    title: "Minister for Food and Civil Supplies ",
    organization: "Government of Kerala",
    details:
      "G.R. Anil is the current Minister for Food and Civil Supplies in Kerala. His ministry has been actively involved in promoting food security, improving transparency in supply chains, and modernizing the PDS infrastructure. Anil's focuses on sustainable food policies and his commitment to addressing hunger and malnutrition",
    // site:'https://minister-highereducation.kerala.gov.in'
  },

  {
    image: leader4,
    name: "Smt. Ishita Roy IAS",
    title: "Principal Secretary",
    organization: "Government of Kerala",
    details:
      "Smt. Ishita Roy, an accomplished Indian Administrative Service (IAS) officer. As Principal Secretary of Higher Education in Kerala, Smt. Ishita Roy has been instrumental in steering educational reforms in the state. Her leadership in this capacity has been focused on modernizing higher education, promoting innovation and research, and ensuring access to quality education for all students.",
  },
  {
    image: leader5,
    name: "Dr. Shalij P R",
    title: "Director of Technical Education",
    organization: "Government of Kerala",
    details:
      "Dr. Shalij P R is a distinguished academician and administrator former, currently serving as the Director of Technical Education (DTE), Kerala. He served as Principal, GEC Thrissur, Dean Research, KTU and many other pivotal roles. In his role as Director of Technical Education, Dr. Shalij is focused on strengthening the link between academia and industry",
  },
  // {
  //   image: leader6,
  //   name: "Dr. Rajasree M S",
  //   title: "Former Directorate of Technical Education",
  //   organization: "Government of Kerala",
  //   details: "With extensive leadership experience as Vice Chancellor, Principal, and Director at various esteemed institutions, she has effectively managed academic and administrative operations while contributing significantly to the field of education and engineering."
  // },
];

export const MICRO_EVENTS_SECTION_DETAILS = [
  {
    title: "Advancements in Manufacturing Technologies",
    details:
      "This is a brief description of Advancements in Manufacturing Technologies. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/0",
  },
  {
    title: "Advancements in Manufacturing Technologies",
    details:
      "This is a brief description of Advancements in Manufacturing Technologies. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/1",
  },
  {
    title: "Advancements in Manufacturing Technologies",
    details:
      "This is a brief description of Advancements in Manufacturing Technologies. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/2",
  },
  {
    title: "Innovative Solutions for Sustainable Water Management",
    details:
      "This is a brief description of Innovative Solutions for Sustainable Water Management. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/3",
  },
  {
    title: "Electric Mobility a Future Technology",
    details:
      "This is a brief description of Electric Mobility a Future Technology. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/4",
  },
  {
    title: "Emerging Technologies in Computing",
    details:
      "This is a brief description of Emerging Technologies in Computing. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/5",
  },
  {
    title: "AI Innovations and Applications",
    details:
      "This is a brief description of AI Innovations and Applications. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/6",
  },
  {
    title: "AI Innovations and Applications",
    details:
      "This is a brief description of AI Innovations and Applications. It covers various important aspects related to the field, providing insights and innovative approaches.",
    link: "https://dummyurl.com/details/7",
  },
];

export const MAIN_EVENT_DETAILS = [
  {
    "title": "INAUGRATION OF EXHIBITION",
    "date": "7th DECEMBER 2024",
    "time": "10 AM",
    "venue": "CSI WOMEN'S CENTRE AUDITORIUM, LMS COMPOUND, PALAYAM",
    image: inaugration,
},
{
"title": "INAUGRATION OF CONCLAVE",
"date": "7th DECEMBER 2024",
"time": "3:30 PM",
"venue": "TAGORE THEATRE, VAZHUTHACAUD",
image: inaugration,
},
{
"title": "EXHIBITION AND PROJECT SHOWCASING",
"date": "7th - 9th DECEMBER 2024",
"time": "10AM TO 9:30 PM",
"venue": "CSI WOMEN'S CENTRE AUDITORIUM, LMS COMPOUND, PALAYAM",
image: panel2,
},
{
"title": "PANEL DISCUSSIONS, SEMINARS AND INDUSTRY INTERACTIONS",
"date": "8th - 10th DECEMBER 2024",
"time": "9:30 AM TO 5:30 PM",
"venue": "MASCOT HOTEL, P.M.G",
image: seminar,
},
{
"title": "CULTURAL NIGHT",
"date": "7th DECEMBER 2024",
"time": "5:30 PM TO 9:30 PM",
"venue": "TAGORE THEATRE",
image: celebration,
},
{
"title": "CULTURAL NIGHT",
"date": "8th & 9th DECEMBER 2024",
"time": "5:30 PM TO 9:30 PM",
"venue": "CSI WOMEN'S CENTRE AUDITORIUM, LMS COMPOUND, PALAYAM",
image: celebration,
},
];

export const DEVELOPERS_SECTION_DETAILS = [
  {
    image: ajaysir,
    name: "Dr. Ajay James",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: premsir,
    name: "Prem Kumar",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: sonisir,
    name: "Prof. Soni P",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: joseph,
    name: "Joseph Pauly",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: manu,
    name: "Manukrishnan P",
    link: "https://dummyurl.com/details/7",
  },

  {
    image: akash,
    name: "Akash Kumar R",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: badu,
    name: "Badusha Pareed",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: hridya,
    name: "Hridya Sivarajan",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: marrea,
    name: "Marrea Treasa Francis",
    link: "https://dummyurl.com/details/7",
  },
  {
    image: pranav,
    name: "Pranav K Thrideep",
    link: "https://dummyurl.com/details/7",
  },
];

